<!--  -->
<template>
  <div class="law-enforcement">
    <div class="banner">
      <div class="banner-text">
        <p class="title">{{$t('safety218')}}</p>
      </div>
    </div>
     <div class="tab-fix">
      <ul class="tab-box">
        <li v-for="item in navData" :key="item.id" @click="current = item.id" :class="{active: item.id === current}">{{item.name}}</li>
      </ul>
    </div>
    <div class="row-line" v-show="current === 'tab-4'">
      <h2 class="title">{{$t('safety220')}}</h2>
      <p class="content">{{$t('safety221')}}</p>
      <p class="content">{{$t('safety222')}}</p>
      <p class="content">{{$t('safety223')}}</p>
      <h2 class="title">{{$t('safety224')}}</h2>
      <p class="content">{{$t('safety225')}}</p>
      <p class="content">{{$t('safety226')}} <a href="mailto:lea@livuchat.com">lea@livuchat.com</a></p>
      <p class="content">{{$t('safety227')}} <br>{{$t('safety228')}}<br>
        {{$t('safety229')}} </p>
      <p class="content">{{$t('safety230')}} <a href="javascript:;" @click="goTab">here</a></p>
      <p class="content">{{$t('safety231')}}</p>
      <p class="content">{{$t('safety232')}}
      </p>
      <p class="content">{{$t('safety233')}}</p>
      <h2 class="title">{{$t('safety234')}}</h2>
      <p class="content">{{$t('safety235')}}</p>
      <h2 class="title">{{$t('safety236')}}</h2>
      <p class="content">{{$t('safety237')}}</p>
      <p class="content" v-html="$t('safety238')"></p>
      <p class="content" v-html="$t('safety239')"></p>
      <p class="content" v-html="$t('safety240')"></p>
      <h2 class="title">{{$t('safety241')}}</h2>
      <p class="content">{{$t('safety242')}}</p>
      <p class="content">{{$t('safety243')}}</p>
      <p class="content">{{$t('safety244')}}</p>
      <h2 class="title">{{$t('safety245')}}</h2>
      <p class="content">{{$t('safety246')}}</p>
      <h2 class="title">{{$t('safety247')}}</h2>
      <p class="content">{{$t('safety248')}}<a href="static/Emergency Request for Informat.pdf" target="_blank" download>here</a></p>
      <p class="content">{{$t('safety249')}}</p>
      <h2 class="title">{{$t('safety250')}}</h2>
      <p class="content">{{$t('safety251')}}</p>
      <h2 class="title">{{$t('safety252')}}</h2>
      <p class="content">{{$t('safety253')}}</p>
      <h2 class="title">{{$t('safety254')}}</h2>
      <p class="content">{{$t('safety255')}}</p>
      <h2 class="title">{{$t('safety256')}}</h2>
      <p class="content">{{$t('safety257')}}</p>
      <h2 class="title">{{$t('safety258')}}</h2>
      <p class="content">{{$t('safety259')}}</p>
      <p class="content">{{$t('safety260')}}</p>
      <h2 class="title">{{$t('safety261')}}</h2>
      <p class="content">{{$t('safety262')}}</p>
      <p class="content">{{$t('safety263')}}</p>
      <h2 class="title">{{$t('safety264')}}</h2>
      <p class="content">{{$t('safety265')}}</p>
    </div>
     <div class="row-line" v-show="current === 'tab-5'" style="line-height: 26px">
      <h2 class="title">{{$t('safety267')}}</h2>
      <p class="content">{{$t('safety268')}}</p>
      <p class="content">{{$t('safety269')}}</p>
      <p class="content">{{$t('safety270')}}</p>
      <h2 class="title">{{$t('safety271')}}</h2>
      <p class="content">{{$t('safety272')}}</p>
      <p class="content"><b>{{$t('safety273')}}</b></p>
      <p class="content">{{$t('safety274')}}</p>
      <p class="content">{{$t('safety275')}}<a href="mailto:lea@livuchat.com">lea@livuchat.com</a></p>
      <p class="content">{{$t('safety276')}}</p>
      <p class="content">
      {{$t('safety277')}}<br>
{{$t('safety278')}}<br>
{{$t('safety279')}}
      </p>
      <p class="content"><b>{{$t('safety280')}}</b></p>
      <p class="content">{{$t('safety281')}}</p>
      <p class="content">{{$t('safety282')}}</p>
      <p class="content" v-html="$t('safety283')"></p>
      <p class="content" v-html="$t('safety284')"></p>
      <p class="content" v-html="$t('safety285')"></p>
      <h2 class="title">{{$t('safety286')}}</h2>
      <p class="content">{{$t('safety287')}}</p>
      <p class="content"><b>{{$t('safety288')}}</b></p>
      <p class="content">
      {{$t('safety289')}}</p>
      <p class="content">{{$t('safety290')}}</p>
      <p class="content">
{{$t('safety291')}}</p>
      <p class="content">
{{$t('safety292')}}</p>
      <p class="content">
{{$t('safety293')}}</p>
      <p class="content">
{{$t('safety294')}}</p>
      <p class="content">{{$t('safety295')}}</p>
      <p class="content">
{{$t('safety296')}}</p>
      <p class="content"><b>{{$t('safety297')}}</b></p>
      <p class="content" v-html="$t('safety298')"></p>
      <p class="content" v-html="$t('safety299')"></p>
      <p class="content" v-html="$t('safety300')"></p>
      <p class="content" v-html="$t('safety301')"></p>
      <p class="content" v-html="$t('safety302')"></p>
      <p class="content" v-html="$t('safety303')"></p>
      <p class="content" v-html="$t('safety304')"></p>
      <p class="content"><b>{{$t('safety305')}}</b></p>
      <p class="content">{{$t('safety306')}}</p>
      <p class="content"><b>{{$t('safety307')}}</b></p>
      <p class="content">{{$t('safety308')}}</p>
      <h2 class="title">{{$t('safety309')}}</h2>
      <p class="content">{{$t('safety310')}}</p>
      <p class="content"><b>{{$t('safety311')}}</b></p>
      <p class="content">
      {{$t('safety312')}}</p>
      <p class="content">
      {{$t('safety313')}}</p>
      <p class="content">
{{$t('safety314')}}</p>
      <p class="content">
{{$t('safety315')}}</p>
      <p class="content">
{{$t('safety316')}}</p>
      <p class="content">
{{$t('safety317')}}</p>
      <p class="content">
{{$t('safety318')}}
      </p>
      <p class="content"><b>{{$t('safety319')}}</b></p>
      <p class="content">{{$t('safety320')}} <a href="static/Emergency Request for Information.pdf" target="_blank" download>here</a></p>
    </div>
    <div class="row-line" v-show="current === 'tab-6'">
      <p class="content"><a href="static/LE or RE Request for Information.pdf" target="_blank" download>{{$t('safety322')}} </a></p>
      <p class="content"><a href="static/Emergency Request for Information.pdf" target="_blank" download>{{$t('safety323')}} </a></p>

      <!-- <ul class="tab-box form">
        <li v-for="item in formsNav" :key="item.id" @click="currentForm = item.id" :class="{active: item.id === currentForm}">{{item.name}}</li>
      </ul>
      <div style="padding-top: 20px;" v-show="currentForm === 'form-1'">
        <h2 class="title">Law Enforcement or Regulator Request for Information (RFI) Form</h2>
        <p class="content">Riley Cillian (“RC”) proactively supports Law Enforcement Requests for Information (“RFI”) and will respond promptly to legal requests from law enforcement officials. To facilitate an RFI, Law Enforcement (“LE”) agencies must attach this RFI form and include all requested, and salient, information necessary to fulfill an RFI.</p>
        <p class="content">To ensure proper handling, please include the following:</p>
        <p class="content">1. LE or RE Requesting Agency Name<br>
2. Requesting Agent/Officer/Official Name<br>
3. Requesting Agent Contact Information and work-authorized e-mail <br>4. LE or RE Requesting Agency Address</p>
        <p class="content">Detailed description of the nature of the information request.</p>
        <p class="text-area">
          <textarea rows="5" cols="5" style="width: 100%; ">
          </textarea>
        </p>
        <p class="content">Identifying information for User or Streamer account. (i.e. Name, User ID, Username, Date of Birth)</p>
        <p class="text-area">
          <textarea rows="5" cols="5" style="width: 100%; ">
          </textarea>
        </p>
        <p class="content">Detailed description of information being requested:</p>
        <p class="text-area">
          <textarea rows="5" cols="5" style="width: 100%; ">
          </textarea>
        </p>
        <p class="input-row">
          I,<input type="text">attest that the above details/facts are true and accurate to the best of my knowledge.
        </p>
         <p class="input-row row1">
           <input type="text" placeholder="Signature of Requesting Official" class="input-w-1">
           <input type="text" placeholder="Date of Submission" style="text-align: right">
          </p>
      </div>
      <div style="padding-top: 20px;" v-show="currentForm === 'form-2'">
        <h2 class="title">Emergency Request for Information (ERFI) Form</h2>
        <p class="content">Riley Cillian (“RC”) proactively supports Emergency Requests for Information (“ERFI”) and will respond promptly to matters involving exigent circumstances and the potential of serious bodily harm or death. To facilitate an ERFI, Law Enforcement (“LE”) agencies must attach this ERFI form and include all requested, and salient, information necessary to fulfill an ERFI.</p>
        <p class="content">To ensure proper handling, please include the following:</p>
        <p class="content">1. LE Requesting Agency Name<br>
2. Requesting Agent/Officer Name<br>
3. Requesting Agent Contact Information and work-authorized e-mail <br>4. LE Requesting Agency Address</p>
        <p class="content">Detailed description of the nature of the emergency. (i.e. potential bodily harm, crime)</p>
        <p class="text-area">
          <textarea rows="5" cols="5" style="width: 100%; ">
          </textarea>
        </p>
        <p class="content">Identifying information for user or streamer account. (i.e. Name, User ID, Username, Date of Birth)</p>
        <p class="text-area">
          <textarea rows="5" cols="5" style="width: 100%; ">
          </textarea>
        </p>
        <p class="content">Detailed explanation of information needed to aid in the resolution of the emergency</p>
        <p class="text-area">
          <textarea rows="5" cols="5" style="width: 100%; ">
          </textarea>
        </p>
        <p class="input-row">
          I,<input type="text">attest that the above details/facts are true and accurate to the best of my knowledge.
        </p>
         <p class="input-row row1">
           <input type="text" placeholder="Signature of Requesting Agent/Officer" class="input-w-2">
           <input type="text" placeholder="Date of Submission" style="text-align: right">
          </p>
      </div> -->
    </div>
    <backTop></backTop>
  </div>
</template>

<script>
import backTop from './back-top.vue'
export default {
  name: 'law-enforcement',
  components: {
    backTop
  },
  data () {
    return {
      tabFix: false,
      current: 'tab-4',
      currentForm: 'form-1',
      navData: [
        // {
        //   name: 'Business Records',
        //   id: 'tab-1'
        // },
        // {
        //   name: 'Legal Process Requirements',
        //   id: 'tab-2'
        // },
        // {
        //   name: 'Request Notice for Users',
        //   id: 'tab-3'
        // },
        {
          name: 'Overview',
          id: 'tab-4'
        },
        {
          name: 'Guidelines',
          id: 'tab-5'
        },
        {
          name: 'Forms',
          id: 'tab-6'
        }
      ],
      formsNav: [
        {
          name: 'Legal RFI ',
          id: 'form-1'
        },
        {
          name: 'Emergency Request',
          id: 'form-2'
        }
      ]
    }
  },
  created () {
    // this.listenerFunction()
  },
  mounted () {
    // this.top = document.querySelector('.top-warp').clientHeight
    // this.posTop = this.$refs.tab.getBoundingClientRect().top
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.listenerFunction)
  },
  methods: {
    goTab () {
      this.current = 'tab-5'
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }
    // listenerFunction (e) {
    //   document.addEventListener('scroll', this.handleScroll, true)
    // },
    // handleScroll (e) {
    //   const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    //   const top = this.posTop - this.top
    //   // console.log(scrollTop, top)
    //   if (scrollTop >= top) {
    //     this.tabFix = true
    //   } else {
    //     this.tabFix = false
    //   }
    // }
  }
}
</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
  .banner {
    width: 100%;
    height: 400px;
    background: url('../assets/images/banner-7.png') no-repeat;
    background-size:  100% 100%;
    .title{
        color: #ffffff;
        font-size: 45px;
        font-weight: bold;
        text-align: center;
        line-height: 400px;
        margin-bottom: 40px;
      }
  }
  input, textarea {
  border: solid #f0f0f0 1px;
  outline: none;

}
input {
  display: flex;
  align-items: flex-end;
  border: none;
  border-bottom: solid #f2f2f2 1px;
  height: 35px;
  font-size: 24px;
}
textarea {
  padding: 10px;
  font-size: 24px;
}
.text-area {
  margin-bottom: 15px;
}
.input-w-1 {
  width: 360px;
}
.input-w-2 {
  width: 480px;
}
.input-row {
  display: inline-block;
  margin-bottom: 15px;
  font-size: 24px;
  &.row1 {
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
  }
  input {
    margin: 0 5px;
    display: inline-block;
  }
}
b {
  font-weight: bold;
}
  .law-enforcement {
    width: 1000px;
    margin: 100px auto 50px auto;
    padding-bottom: 40px;
    .tab-fix {
      width: 100%;
      position: fixed;
      top: 120px;
      left: 0;
      padding-top: 40px;
      padding-bottom: 30px;
      background-color: #ffffff;
      &.fix {
        position: fixed;
        top: 120px;
        left: 0;
      }
    }
    .tab-box {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        align-items: flex-end;
        &.form {
          border-bottom: solid #eeeeee 2px;
          background-color: #fafafa;
          padding: 10px 15px 0 15px;
          li {
            min-height: 45px;
            display: flex;
            align-items: center;
            font-weight: normal;
            color: #888;
            position: relative;
            padding: 0 20px;
            margin: 0;
            &.active {
              font-weight: bold;
              color: #000;
              background-color: #fff;
              &::before {
                left: 0;
                bottom: -2px;
                width: 100%;
                transform: translateX(0);
                background-color: #fff;
              }
            }
          }
        }
        li {
          margin-right: 30px;
          text-align: center;
          cursor: pointer;
          font-size: 24px;
          font-weight: bold;
          color: #333;
          position: relative;
          &.active::before {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -10px;
            width: 38px;
            height: 3px;
            background-color: $primary;
            transform: translateX(-50%)
          }
        }
      }
    .row-content {
      width: 970px;
      margin: 0 auto;
      padding-bottom: 40px;
      .title {
        font-size: 40px;
        line-height: 47px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        color: #6B6B6B;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 15px;
      }
    }
    .row-line {
      margin-bottom: 40px;
      text-align: left;
      .title {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .content {
        font-size: 24px;
        color: #5e5e5e;
        margin-bottom: 20px;
        line-height: 28px;
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        &>a {
          display: inline-block;
          width: 282px;
          height: 60px;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          border-radius: 8px;
          text-decoration: none;
        }
      }
    }
    .red {
      color: #F94A27;
    }
  }
}
@media (max-width: 750px) {
.to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
.banner {
    width: 100%;
    height: 100px;
    background: url('../assets/images/banner-7.png') no-repeat;
    background-size:  100% 100%;
    .title{
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 100px;
        margin-bottom: 40px;
      }
  }
input, textarea {
  border: solid #f0f0f0 1px;
  outline: none;

}
input {
  display: flex;
  align-items: flex-end;
  border: none;
  border-bottom: solid #f2f2f2 1px;
  height: 35px;
  font-size: 14px;
}
textarea {
  padding: 10px;
  font-size: 14px;
}
.text-area {
  margin-bottom: 15px;
}
.input-w-1 {
  width: 100%;
}
.input-w-2 {
  width: 100%;
}
.input-row {
  margin-bottom: 15px;
  font-size: 14px;
  &.row1 {
    input {
      width: 100%;
      text-align: right;
      margin-top: 10px;
    }
  }
  input {
    margin: 0 5px;
    display: inline-block;
  }
}
b {
  font-weight: bold;
}
  .law-enforcement {
    padding:80px 25px 10px 25px;
    .tab-fix {
      width: 100%;
      position: fixed;
      top: 56px;
      left: 0;
      padding: 30px 25px 25px 25px;
      background-color: #ffffff;
      &.fix {
        position: fixed;
        top: 56px;
        left: 25px;
      }
    }
    .tab-box {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        &.form {
          border-bottom: solid #eeeeee 2px;
          background-color: #fafafa;
          padding: 10px 15px 0 15px;
          li {
            min-height: 25px;
            display: flex;
            align-items: center;
            font-weight: normal;
            color: #888;
            position: relative;
            padding: 0 20px;
            margin: 0;
            &.active {
              font-weight: bold;
              color: #000;
              background-color: #fff;
              &::before {
                left: 0;
                bottom: -2px;
                width: 100%;
                transform: translateX(0);
                background-color: #fff;
              }
            }
          }
        }
        li {
          margin-right: 18px;
          text-align: center;
          cursor: pointer;
          font-size: 12px;
          font-weight: bold;
          color: #333;
          position: relative;
          margin-bottom: 15px;
          &.active::before {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -10px;
            width: 38px;
            height: 3px;
            background-color: $primary;
            transform: translateX(-50%)
          }
        }
      }
    .row-content {
      .title {
        font-size: 22px;
        line-height: 26px;
        font-weight: bold;
        color: #333;
        margin-bottom: 15px;
      }
      .content {
        color: #6B6B6B;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 10px;
      }
    }
    .row-line {
      text-align: left;
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }
      .content {
        font-size: 14px;
        color: #5e5e5e;
        margin-bottom: 15px;
        line-height: 18px;
      }
    }
    .red {
      color: #F94A27;
    }
  }
}
</style>
